import React from 'react';

export default function EvaluasiPerusahaan() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Evaluasi Perusahaan</h1>
      <p className="text-gray-500">Halaman Evaluasi Perusahaan</p>
    </div>
  );
}
